import { FC } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import Failure from 'images/icon/failure.svg';

import styles from './RewardFailure.module.scss';
export const RewardFailure: FC = () => {
  const navigate = useNavigate();
  const { id: idParam } = useParams<{ id?: string }>();
  const id =
    idParam === 'halfway' || idParam === 'almost' || idParam === 'perfect' ? idParam : 'halfway';
  usePageTitle(
    id === 'halfway'
      ? '5エリアクリア'
      : id === 'almost'
      ? '10エリアクリア'
      : id === 'perfect'
      ? 'パーフェクト賞'
      : '記念品受け取り'
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <img src={Failure} alt="" className={styles.Icon} />
          <p className={styles.message}>二次元コード読み取り失敗！</p>
          <p className={styles.text}>
            読み取った二次元コードが正しくないみたい...
            <br />
            お店の人に確認してみてね。
          </p>
        </div>
        <div className={styles.foot}>
          <Button text="ホームに戻る" styleType="secondary" handleClick={() => navigate('/home')} />
        </div>
      </div>
    </div>
  );
};
